import * as React from 'react';
import { PaginatedClientContext } from '../shared/paginated-client-context';
import useClient from '../hooks/useClient';
import Client from '../models/client';
import FetchOptions from '../components/management/pagination/fetch-options';

/**
 * usePaginatedClients
 * @function usePaginatedClients - Custom hook for the client management page
 */
const usePaginatedClients = () => {
  const { loading, dispatch, results, totalResults } = React.useContext(PaginatedClientContext);
  const { fetchAdminClients } = useClient();

  /**
   * fetchClientsPage
   * @function fetchClients - Fetches the clients from the backend and sets them to the state
   * @param options - Optional FetchOptions
   */
  const fetchClientsPage = (options?: FetchOptions) => {
    dispatch({ loading: true });
    return fetchAdminClients(
      options.currentPage,
      options.pageSize,
      options.searchTerm,
      options.orderColumn,
      options.orderDirection
    )
      .then((response: { results: Client[]; totalItems: number }) => {
        dispatch({
          loading: false,
          currentPage: options.currentPage,
          pageSize: options.pageSize,
          results: response.results,
          totalResults: response.totalItems,
          orderColumn: options.orderColumn,
          orderDirection: options.orderDirection,
          searchTerm: options.searchTerm
        });
      })
      .catch(() => console.log('Failed to get clients.'));
  };

  return {
    loading,
    results,
    fetchClientsPage,
    totalResults
  };
};

export default usePaginatedClients;
